export default __webpack_public_path__ + "static/media/manual-cleaning-01.4272c716.png";